import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from 'react';
import { ApiPromise, WsProvider } from '@polkadot/api';
import { initialBalancesState, SubstraHooksContext } from './context';
import { fetchSystemProperties, systemPropertiesDefaults, } from '../../helpers/fetch-system-properties';
import { ExtensionProvider } from '../extension';
import { useIsMountedRef } from '../../helpers/use-is-mounted-ref';
import { balancesReducer } from './reducer';
const _apiProviders = {};
export const initPolkadotPromise = async (id, wsProviderUrl, types) => {
    if (_apiProviders[id])
        return _apiProviders[id];
    let polkadotApi = null;
    let systemProperties = systemPropertiesDefaults;
    try {
        const wsProvider = new WsProvider(wsProviderUrl);
        polkadotApi = await ApiPromise.create({ provider: wsProvider, types: types, throwOnConnect: true });
        await polkadotApi.isReady;
        systemProperties = await fetchSystemProperties(polkadotApi);
        _apiProviders[id] = {
            systemProperties,
            apiProvider: polkadotApi,
        };
    }
    catch (error) {
        console.warn(`RPC ${wsProviderUrl} has failed with an error`, error);
    }
    _apiProviders[id] = {
        systemProperties,
        apiProvider: polkadotApi,
    };
    return _apiProviders[id];
};
const initAllApis = async (apiProviderConfig) => {
    await Promise.all(Object.keys(apiProviderConfig).map(async (configId) => initPolkadotPromise(apiProviderConfig[configId].id, apiProviderConfig[configId].wsProviderUrl, apiProviderConfig[configId].types)));
    return _apiProviders;
};
export const SubstraHooksProvider = ({ children, apiProviderConfig, defaultApiProviderId, autoInitialiseExtension, }) => {
    const [apiProviders, setApiProviders] = useState({});
    const [balancesState, balancesDispatch] = useReducer(balancesReducer, initialBalancesState);
    const isMountedRef = useIsMountedRef();
    useEffect(() => {
        if (apiProviderConfig) {
            initAllApis(apiProviderConfig).then((apiProviders) => {
                if (isMountedRef.current) {
                    setApiProviders(apiProviders);
                }
            });
        }
    }, [JSON.stringify(apiProviderConfig), isMountedRef]);
    return (_jsx(SubstraHooksContext.Provider, Object.assign({ value: { apiProviders, defaultApiProviderId, balancesState, balancesDispatch } }, { children: _jsx(ExtensionProvider, Object.assign({ autoInitialiseExtension: autoInitialiseExtension }, { children: children }), void 0) }), void 0));
};
//# sourceMappingURL=provider.js.map